import { useEffect, useState } from "react";
import Select from "react-select";

export const SelectSearch = ({
  array,
  idPregunta,
}) => {
  const options = array.map((option) => ({
    value: option.RespuestaId,
    label: option.RespuestaTexto,
  }));

  const [seleccion, setSeleccion] = useState(null);

  return (
    <>
      <input
        type="hidden"
        id={"Autocomplete"}
        name={idPregunta}
        value={seleccion?.value || ""}
      />

      <Select
        options={options}
        onChange={(opcion) => setSeleccion(opcion)}
        placeholder="Ingrese una palabra para buscar."
        isClearable
        styles={{
          container: (base) => ({
            ...base,
            width: "100%",
          })
        }}
        className="form-encuesta-select"
        classNamePrefix="react-select"
      />
    </>
  );
};
